import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en', // 将要切换的语言，默认取本地缓存的值，若本地没有缓存则默认英语
  messages: {
    vi: require('@/assets/languages/vi.json'),
    en: require('@/assets/languages/en.json'),
    cn: require('@/assets/languages/cn.json'),
    ja: require('@/assets/languages/ja.json')
  }
})
// ***
// 非 vue 文件中使用这个方法
const translate = (localeKey) => {
  const locale = localStorage.getItem('lang') || 'en'
  const hasKey = i18n.te(localeKey, locale) // 使用i18n的 te 方法来检查是否能够匹配到对应键值
  const translatedStr = i18n.t(localeKey)
  if (hasKey) {
    return translatedStr
  }
  return localeKey
}

export { i18n, translate }



// WEBPACK FOOTER //
// ./src/assets/languages/index.js